import React from 'react'
import { Form } from 'antd'
import styled from 'styled-components'
import { DEFAULT_REQUIRED_FIELD_MESSAGE } from 'components/Assessments/constants'
import { RadioQuestionProps } from '../types'
import LabelAndDescriptionFieldLayout from '../FieldLayout/LabelAndDescriptionFieldLayout'
import QuestionContainer from '../QuestionContainer'
import RadioField from '../RadioField'

const Container = styled.div`
  margin: 16px 0;
`

function RadioQuestion({
  field,
  formFieldName,
  layout,
  answersLayout,
  disabled = false,
  required = false,
  customRules = [],
  customOptions
}: RadioQuestionProps): JSX.Element {
  // Auto-detect description from field extensions
  const secondaryText = field?.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.display

  // Use custom options if provided, otherwise fall back to field answerOptions
  const options = customOptions
    ? customOptions.map((option) => ({
        label: option.label,
        value: String(option.value)
      }))
    : field.answerOption?.map((option) => ({
        label: option?.valueCoding?.display,
        value: option?.valueCoding?.code ?? option?.valueCoding?.display
      }))
  // Combine default required rule with custom rules
  const allRules = [
    {
      required: Boolean(required && field.required),
      message: DEFAULT_REQUIRED_FIELD_MESSAGE
    },
    ...customRules
  ]

  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <LabelAndDescriptionFieldLayout
          label={field.text}
          secondaryText={secondaryText}
          layout={layout}
        >
          <Form.Item name={formFieldName} rules={allRules} style={{ margin: 0 }}>
            <RadioField
              id={formFieldName}
              disabled={disabled}
              options={options}
              layout={answersLayout}
            />
          </Form.Item>
        </LabelAndDescriptionFieldLayout>
      </Container>
    </QuestionContainer>
  )
}

export default RadioQuestion
